module.exports = __webpack_public_path__ + "img/blood-and-sand.c287b2df.jpg";